import LeadsSummary from './LeadsSummary';
export default LeadsSummary;
